import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '../theme';
import compose from '../utils/compose';
import { isolateMixin } from '../utils/mixins';
import windowEvents from '../hoc/window-events';

var styles = function styles(_ref) {
  var fontFamily = _ref.fontFamily,
      tagsInput = _ref.tagsInput;
  return _extends({
    root: {
      extend: isolateMixin,
      fontSize: tagsInput.fontSize,
      fontFamily: fontFamily,
      fontWeight: 400,
      userSelect: 'none',
      overflow: 'hidden'
    },
    items: {
      display: 'flex',
      '$isDisabled &': {
        pointerEvents: 'none'
      }
    },
    isExpanded: {
      '& $items': {
        flexWrap: 'wrap'
      }
    },
    item: {
      '&&': {
        flex: 'none',
        alignSelf: 'flex-start',
        whiteSpace: 'nowrap'
      }
    },
    more: {
      composes: '$item',
      color: tagsInput.colors.default.more,
      transition: 'color .2s',
      '$isDisabled &': {
        color: tagsInput.colors.disabled.more
      }
    },
    isClickable: {
      pointerEvents: 'auto',
      '$isEnabled &': {
        cursor: 'pointer',
        '&:hover': {
          color: tagsInput.colors.hover.more
        },
        '&:active': {
          color: tagsInput.colors.active.more
        }
      },
      '$isDisabled &': {
        cursor: 'not-allowed'
      }
    },
    regular: {},
    background: {}
  }, ['regular', 'background'].reduce(function (typesResult, type) {
    var _tagsInput$types$type = tagsInput.types[type],
        height = _tagsInput$types$type.height,
        verticalGap = _tagsInput$types$type.verticalGap,
        horizontalGap = _tagsInput$types$type.horizontalGap;
    return _extends({}, typesResult, _defineProperty({}, type, {
      '& $items': {
        marginTop: -verticalGap,
        marginLeft: -horizontalGap,
        minHeight: height + verticalGap
      },
      '& $item': {
        marginTop: verticalGap,
        marginLeft: horizontalGap,
        maxWidth: "calc(100% - ".concat(horizontalGap, "px)"),
        lineHeight: "".concat(height, "px")
      }
    }));
  }, {}), {
    isHidden: {
      '&&': {
        order: 1,
        visibility: 'hidden'
      }
    },
    isEnabled: {},
    isDisabled: {}
  });
};

var TagsInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(TagsInput, _PureComponent);

  var _super = _createSuper(TagsInput);

  function TagsInput() {
    var _this;

    _classCallCheck(this, TagsInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      visibleItemsCount: null,
      containerWidth: null
    };
    _this.items = [];
    _this.container = null;
    _this.moreButton = null;

    _this.handleWindowResize = function () {
      _this.setState({
        containerWidth: Math.floor(_this.container.getBoundingClientRect().width)
      });
    };

    _this.saveItemsRefs = function (ref, index, length) {
      _this.items.length = length;
      _this.items[index] = ref;
    };

    _this.saveContainerRef = function (ref) {
      _this.container = ref;
    };

    _this.saveMoreButtonRef = function (ref) {
      _this.moreButton = ref;
    };

    _this.onItemRemove = function (event, value) {
      if (_this.props.disabled) return;
      event.stopPropagation();
      var values = Children.toArray(_this.props.children).map(function (item) {
        return item.props.value;
      });

      _this.props.onChange(values.filter(function (item) {
        return item !== value;
      }));
    };

    return _this;
  }

  _createClass(TagsInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.windowEvents.on('resize', this.handleWindowResize, false);
      if (!this.props.isExpanded) this.updateVisibleItemsCount();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (Children.count(this.props.children) === 0) this.items = [];
      if (this.shouldVisibleItemsCountUpdate(this.state, prevState, this.props, prevProps)) this.updateVisibleItemsCount();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.windowEvents.removeListener('resize', this.handleWindowResize, false);
    }
  }, {
    key: "shouldVisibleItemsCountUpdate",
    value: function shouldVisibleItemsCountUpdate(state, prevState, props, prevProps) {
      if (props.isExpanded) return false;
      if (props.isExpanded !== prevProps.isExpanded) return true;
      if (state.containerWidth !== prevState.containerWidth) return true;
      var items = Children.toArray(props.children);
      var prevItems = Children.toArray(prevProps.children);
      var itemsCount = items.length;
      if (itemsCount !== prevItems.length) return true;

      while (itemsCount--) {
        if (items[itemsCount].props.children !== prevItems[itemsCount].props.children) return true;
      }

      return false;
    }
  }, {
    key: "updateVisibleItemsCount",
    value: function updateVisibleItemsCount() {
      var items = this.items.filter(Boolean);
      var itemsCount = items.length;

      if (itemsCount < 1) {
        this.setState({
          visibleItemsCount: null
        });
        return;
      }

      var props = this.props;
      var horizontalGap = props.theme.tagsInput.types[props.type].horizontalGap;
      var containerWidth = Math.floor(this.container.getBoundingClientRect().width);
      var moreButtonWidth = Math.ceil(this.moreButton.getBoundingClientRect().width) + horizontalGap;
      var index = 0;
      var itemsWidthSum = 0;

      while (index < itemsCount) {
        var itemWidth = Math.ceil(this.items[index].getBoundingClientRect().width) + horizontalGap;
        var iterationWidth = index < itemsCount - 1 ? itemWidth + moreButtonWidth : itemWidth;
        if (itemsWidthSum + iterationWidth > containerWidth) break;
        itemsWidthSum += itemWidth;
        index += 1;
      }

      this.setState({
        visibleItemsCount: index < itemsCount ? index : null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disabled = _this$props.disabled,
          classes = _this$props.classes,
          isExpanded = _this$props.isExpanded,
          onMoreClick = _this$props.onMoreClick,
          type = _this$props.type,
          onChange = _this$props.onChange,
          theme = _this$props.theme,
          windowEvents = _this$props.windowEvents,
          other = _objectWithoutProperties(_this$props, ["children", "className", "disabled", "classes", "isExpanded", "onMoreClick", "type", "onChange", "theme", "windowEvents"]);

      var visibleItemsCount = this.state.visibleItemsCount;
      var resultClassName = classnames(className, classes.root, classes[type], disabled ? classes.isDisabled : classes.isEnabled, isExpanded && classes.isExpanded);
      var count = Children.count(children);
      var items = Children.map(children, function (child, i) {
        if (!child.type || child.type.displayName !== 'RamblerUI(TagsInputItem)') throw new Error('Child component should be instance of <TagsInputItem />');
        var isHidden = !isExpanded && visibleItemsCount !== null && visibleItemsCount <= i;
        return cloneElement(child, {
          nodeRef: function nodeRef(ref) {
            _this2.saveItemsRefs(ref, i, count);
          },
          className: classnames(child.props.className, classes.item, isHidden && classes.isHidden),
          key: child.props.children,
          onRemove: onChange ? _this2.onItemRemove : undefined,
          type: type,
          disabled: disabled
        });
      });
      var moreCount = visibleItemsCount === null ? 0 : items.length - visibleItemsCount;
      return React.createElement("div", _extends({
        className: resultClassName
      }, other), React.createElement("div", {
        ref: this.saveContainerRef,
        className: classes.items
      }, items, !isExpanded && React.createElement("div", {
        className: classnames(classes.more, onMoreClick && classes.isClickable, moreCount === 0 && classes.isHidden),
        role: onMoreClick ? 'button' : undefined,
        ref: this.saveMoreButtonRef,
        onClick: disabled ? undefined : onMoreClick
      }, "+", moreCount)));
    }
  }]);

  return TagsInput;
}(PureComponent);

TagsInput.defaultProps = {
  type: 'regular'
};
TagsInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   *  Элементы инпута, обязаны быть компонентами типа <TagsInputItem />
   */
  children: PropTypes.node,

  /**
   * Задизэйблить
   */
  disabled: PropTypes.bool,

  /**
   * Класс контейнера
   */
  className: PropTypes.string,

  /**
   * Открыт/Закрыт список элементов
   */
  isExpanded: PropTypes.bool,

  /**
   * Коллбек вызывающийся при изменении состояния
   */
  onChange: PropTypes.func,

  /**
   * Коллбек вызывающийся при нажатии на кнопку "еще"
   */
  onMoreClick: PropTypes.func,

  /**
   * Разновидность тегов
   */
  type: PropTypes.oneOf(['regular', 'background'])
} : {};
export default compose(windowEvents('resize'), withStyles(styles, {
  name: 'TagsInput'
}))(TagsInput);